import { useEffect, useState } from 'react';
import { UserAttributeKeys } from '../../userAttributes';
import { useUserAttribute } from '../../userAttributes/userAttributesQueries.migrated';
import { playlistSurveyId } from '../savedItemsConstants.migrated';
import { useIsPlaylistRoute } from 'academy-common-lib/features/savedItems/savedItemsHooks';
// @ts-expect-error Could not find a declaration file for module 'feedback-loader/useFeedbackLoader'.
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
export const PlaylistSurvey = () => {
  const isPlaylistsPath = useIsPlaylistRoute();
  const {
    userAttribute,
    userAttributeLoading,
    userAttributesError
  } = useUserAttribute(UserAttributeKeys.HAS_VIEWED_PLAYLIST);
  const [isInitialCheck, setIsInitialCheck] = useState(true);
  const [isNewPlaylistUser, setIsNewPlaylistUser] = useState(true);
  useEffect(() => {
    if (userAttributeLoading || userAttributesError) {
      return;
    }
    if (isInitialCheck) {
      setIsInitialCheck(false);
      if (userAttribute) {
        setIsNewPlaylistUser(false);
      }
    }
  }, [userAttributeLoading, userAttributesError, userAttribute, isInitialCheck]);
  const {
    loadSurvey,
    clientLoaded
  } = useFeedbackLoader();
  useEffect(() => {
    if (isNewPlaylistUser || !isPlaylistsPath || !clientLoaded) {
      return;
    }
    loadSurvey(playlistSurveyId, 'CSAT');
  }, [isNewPlaylistUser, isPlaylistsPath, clientLoaded, loadSurvey]);
  return null;
};